import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, fetchData1 } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import Tooltip from '@mui/material/Tooltip';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

function ReIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteMember, setDeleteMember] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [fromdate, setFromDate] = useState("");  // From date state
    const [interval, setInterval] = useState(5);  // Default interval is 5 days
    const [todate, setTodate] = useState("");  // To date state

    const history = useHistory(); // Access the navigation history

    const { isAuthenticated, clubId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [selectedMembers, setSelectedMembers] = useState({});

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, clubId, branchId, token, logout]);
    // Recalculate 'To date' when 'From date' or 'Interval' changes
    useEffect(() => {
        if (fromdate && interval) {
            const calculatedToDate = calculateToDate(fromdate, interval);
            setTodate(calculatedToDate);  // Update the 'To date'
            //fetchtableData();
        }
    }, [fromdate, interval]);  // Dependencies: Recalculate when either 'From date' or 'Interval' changes

    const fetchtableData = async () => {
        try {
            const response = await fetchData1('ReportsApi', `/${clubId}/${branchId}/${fromdate}/${interval}/Reminder`, token);

            if (response.responseCode === '1111') {
                console.log('Fetched Data:', response);
                setData(response.response_data);
            } else {
                console.warn('Response indicates an issue:', response);
            }
        } catch (error) {
            if (error.response) {
                console.error('Server Error:', error.response.data);
                console.error('Status Code:', error.response.status);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Unexpected Error:', error.message);
            }
        }
    };

    // Function to calculate 'To date' based on 'From date' and 'Interval' changes
    const calculateToDate = (fromDate, interval) => {
        const from = new Date(fromDate);

        // Add the interval (in days) to the 'From date'
        from.setDate(from.getDate() + interval);

        // Return 'To date' in YYYY-MM-DD format
        return from.toISOString().split('T')[0];
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };



    // Fetch data only after financial year is set
    useEffect(() => {
        const currentDate = new Date().toISOString().split('T')[0];  // Get current date in YYYY-MM-DD format
        setFromDate(currentDate);  // Set today's date as default 'From date'
    }, []);
    const handleRefresh = () => {
        fetchtableData();  // Trigger fetch table data when the refresh button is clicked
    };
    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">


            <div className='w-full mb-1 flex'>

                <h6 className='productHead flex-grow linkcolor'
                    style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    REMINDER</h6>


                {/* <div className="button-container-1">

                    <Tooltip title="Refresh to get reminders in selected days" arrow>

                        <Button
                            component={Link}
                            onClick={handleRefresh}
                            className="linkcolor"
                            style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#347928', height: '25px' }}
                        >
                            Refresh
                        </Button>
                    </Tooltip>

                </div> */}


            </div>


            <div className="w-full grid grid-cols-6 gap-2 mb-1">
                <div>
                    <label htmlFor="year">From</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        value={fromdate}
                        onChange={(e) => setFromDate(e.target.value)}  // Update 'From date' on input change
                        type="date"
                        placeholder="Select Date"
                    />
                </div>

                <div className="mb-4">
                    {/* Remind label and input */}
                    <label htmlFor="remind" className="block mb-1">Remind</label>
                    <div className="flex items-center space-x-2">
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={interval}
                            onChange={(e) => setInterval(e.target.value)} // Allowing the user to edit the interval
                            type="text" // Input type set to text (can also use number if only numbers are expected)
                            placeholder="Interval"
                        />
                        <label htmlFor="interval" className="flex-shrink-0"> Days prior to event</label>
                    </div>
                </div>
                <div className="button-container-1">
                    <Tooltip title="Refresh to get reminders in selected days" arrow>

                        <Button style={{ backgroundColor: '#27391C', color: 'white', fontWeight: 'bold', marginTop: '20px', height: '25px' }}
                                 
                            component={Link}
                            onClick={handleRefresh}
                            className="linkcolor"
                           >
                            Refresh
                        </Button>



                    </Tooltip>
                </div>
            </div>

            {/* Table for displaying fetched data */}
            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto',marginTop:'-20px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        {/* <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}> */}
                        <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Sl No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Event</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Member Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Happening On</TableCell>
                            </TableRow>
                        </TableHead>


                        <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                            {data.map((reminder, index) => (

                                <TableRow
                                    key={reminder.id}
                                    className={reminder.isActive ? '' : 'inactiveRow'}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fcff', // Alternate row background colors
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px' }}>{reminder.event}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px' }}>{reminder.member}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px' }}>{formatDateForInput(reminder.happeningon)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default ReIndex;
